module.exports = __webpack_public_path__ + "static/media/bet-yellow-3.a2dc6dba.png";